(function(){
  function initSlider(root){
    var range = root.querySelector('[data-fey-range]');
    var before = root.querySelector('[data-fey-before]');
    var handle = root.querySelector('[data-fey-handle]');
    if(!range || !before || !handle) return;
    function update(){
      var v = range.value;
      before.style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)';
      handle.style.left = v + '%';
    }
    range.addEventListener('input', update);
    update();
  }
  function initAll(context){
    var scope = context || document;
    scope.querySelectorAll('[data-fey-proof]').forEach(initSlider);
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){
    initAll(e.target);
  });
})();